"use strict";

var version = require('./meta.json').version;

function depCheck() {
  var depList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var props = arguments.length > 1 ? arguments[1] : undefined;
  var currentMajorVersion = parseInt(('' + version).split('.')[0]);
  depList.forEach(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$condition = _ref.condition,
        condition = _ref$condition === void 0 ? function () {} : _ref$condition,
        _ref$message = _ref.message,
        message = _ref$message === void 0 ? '' : _ref$message,
        _ref$breakingVersion = _ref.breakingVersion,
        breakingVersion = _ref$breakingVersion === void 0 ? '' : _ref$breakingVersion;

    var breakingMajorVersion = parseInt(('' + breakingVersion).split('.')[0]);
    var errMsg;

    if (condition(props)) {
      if (currentMajorVersion >= breakingMajorVersion) {
        errMsg = "[@uitk/ui-toolkit-react]: DEPRECATED FEATURE \u2013 ".concat(message);
        throw new TypeError(errMsg);
      } else {
        errMsg = "[@uitk/ui-toolkit-react]: DEPRECATION NOTICE \u2013 ".concat(message);
        console.warn(errMsg);
      }
    }
  });
}

module.exports = depCheck;
